import React, { useEffect, useRef } from 'react';
import {
  Overlay,
  Caixa,
  Titulo,
  Texto,
  Acoes,
  BotaoOk,
} from './feedback-modal.style';

interface FeedbackModalProps {
  /** Mensagem exibida. Vazio ou indefinido nao renderiza o modal. */
  mensagem: string;
  /** true pinta o titulo de vermelho e troca o texto do cabecalho. */
  erro?: boolean;
  /** Chamado quando o usuario confirma (botao OK ou tecla Esc). */
  onConfirmar: () => void;
}

export default function FeedbackModal({
  mensagem,
  erro,
  onConfirmar,
}: FeedbackModalProps) {
  const botaoRef = useRef<HTMLButtonElement>(null);

  // O cliente precisa confirmar para seguir, entao o foco vai direto para o OK:
  // quem navega por teclado nao fica procurando onde o modal abriu.
  useEffect(() => {
    if (mensagem) {
      botaoRef.current?.focus();
    }
  }, [mensagem]);

  useEffect(() => {
    if (!mensagem) return;

    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onConfirmar();
      }
    };

    window.addEventListener('keydown', aoTeclar);
    return () => window.removeEventListener('keydown', aoTeclar);
  }, [mensagem, onConfirmar]);

  if (!mensagem) return null;

  return (
    <Overlay
      role="dialog"
      aria-modal="true"
      aria-labelledby="feedback-modal-titulo"
    >
      <Caixa>
        <Titulo id="feedback-modal-titulo" erro={erro}>
          {erro ? 'Não foi possível enviar' : 'Solicitação enviada'}
        </Titulo>
        <Texto>{mensagem}</Texto>
        <Acoes>
          <BotaoOk ref={botaoRef} type="button" onClick={onConfirmar}>
            OK
          </BotaoOk>
        </Acoes>
      </Caixa>
    </Overlay>
  );
}
